import React from 'react';
import PropTypes from 'prop-types';

export default function CalendarIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 13 17" {...rest}>
      <path
        fill={color}
        d="M0.880733945,3.92022792 L13.5192661,3.92022792 L13.5192661,2.00569801 L11.6697248,2.00569801 L11.6697248,3.14529915 C11.0091743,3.14529915 10.3045872,3.14529915 9.6440367,3.14529915 L9.6440367,2.00569801 L4.7559633,2.00569801 L4.7559633,2.68945869 L4.7559633,3.14529915 L4.31559633,3.14529915 L3.1706422,3.14529915 L2.73027523,3.14529915 L2.73027523,2.68945869 L2.73027523,2.00569801 L0.880733945,2.00569801 L0.880733945,3.92022792 Z M13.5192661,4.83190883 L0.880733945,4.83190883 L0.880733945,15.0883191 L13.5192661,15.0883191 L13.5192661,4.83190883 Z M2.73027523,1.09401709 L2.73027523,0 C3.39082569,0 4.09541284,0 4.7559633,0 L4.7559633,1.09401709 L9.6440367,1.09401709 L9.6440367,0 C10.3045872,0 11.0091743,0 11.6697248,0 L11.6697248,1.09401709 L14.4,1.09401709 L14.4,16 L0,16 L0,1.09401709 L2.73027523,1.09401709 Z M3.87522936,0.911680912 L3.61100917,0.911680912 L3.61100917,2.23361823 L3.87522936,2.23361823 L3.87522936,0.911680912 Z M10.7889908,0.911680912 L10.5247706,0.911680912 L10.5247706,2.23361823 L10.7889908,2.23361823 L10.7889908,0.911680912 Z"
      />
    </svg>
  );
}

CalendarIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

CalendarIcon.defaultProps = {
  size: 15,
  color: '#000',
};
